import type { FC } from "react";
import React from "react";

import classes from "./AvatarGift.styl";

export type AvatarGiftSize = number | `${number}`;

interface IAvatarGiftProps {
    /** URL изображения подарка */
    src: string;
    /** Alt-атрибут изображения подарка */
    alt: string;
    /** Ширина изображения подарка */
    width: AvatarGiftSize;
    /** Высота изображения подарка */
    height: AvatarGiftSize;
}

export const AVATAR_GIFT_IMAGE_TEST_ID = "avatar-gift-image-test-id";

export const AvatarGift: FC<IAvatarGiftProps> = (props) => {
    return (
        // Alt-атрибут передаётся, поэтому дизейблим eslint-правило
        // eslint-disable-next-line jsx-a11y/alt-text
        <img
            {...props}
            className={classes["image"]}
            data-tsid={AVATAR_GIFT_IMAGE_TEST_ID}
        />
    );
};

AvatarGift.displayName = "Avatar.Gift";

export default AvatarGift;
